import { useState } from 'react'
import img1 from '../assets/1.webp'
import img2 from '../assets/2.webp'
import img3 from '../assets/3.webp'
import img4 from '../assets/4.webp'
import rudraksh from '../assets/rudraksh.jpg'
import rudrakshJ from '../assets/rudraksh_j.jpg'

/* ===================== SHOP ===================== */
const SHOP = [
  { name: 'Yellow Sapphire (Pukhraj)', img: img1, price: 51310, cat: 'gemstone', stars: 4, tag: 'Gemstone' },
  { name: '1 Mukhi Rudraksha – Limited', img: rudrakshJ, price: 6899, cat: 'rudraksha', stars: 4, tag: 'Rudraksha' },
  { name: 'Yellow Sapphire Premium', img: img2, price: 28420, cat: 'gemstone', stars: 4, tag: 'Gemstone' },
  { name: 'Blue Sapphire (Neelam)', img: img3, price: 45000, cat: 'gemstone', stars: 5, tag: 'Gemstone' },
  { name: '5 Mukhi Rudraksha Mala', img: rudraksh, price: 3500, cat: 'rudraksha', stars: 5, tag: 'Rudraksha' },
  { name: 'Shree Sri Yantra (Gold)', img: img4, price: 2100, cat: 'yantra', stars: 5, tag: 'Yantra' },
]
const SHOP_FILTERS = [{ k: 'all', l: 'All' }, { k: 'gemstone', l: '💎 Gemstones' }, { k: 'rudraksha', l: '📿 Rudraksha' }, { k: 'yantra', l: '🔱 Yantra' }]

export default function ShopTab() {
  const [cat, setCat] = useState('all')
  const items = SHOP.filter((p) => cat === 'all' || p.cat === cat)
  return (
    <div className="space-y-6">
      <div className="dash-card p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-1">
          <span className="eyebrow text-amber-700">Divine Shop</span>
        </div>
        <h3 className="text-xl text-astroDark mb-4 font-royal">Gemstones, Rudraksha &amp; Yantras</h3>
        <div className="flex flex-wrap gap-2 mb-6">
          {SHOP_FILTERS.map((f) => (
            <button key={f.k} onClick={() => setCat(f.k)} className={`px-4 py-1.5 rounded-full text-[10.5px] font-bold border transition-all ${cat === f.k ? 'bg-gradient-to-r from-goldAccent to-goldPrimary text-astroDark border-transparent shadow-[0_6px_16px_-6px_rgba(245,158,11,0.55)]' : 'text-stone-500 border-[rgba(120,53,15,0.14)] bg-white hover:text-goldAccent'}`}>{f.l}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => (
            <div key={p.name} className="browse-card flex flex-col">
              <div className="relative h-40 bg-cover bg-center bg-amber-50" style={{ backgroundImage: `url('${p.img}')` }}>
                <span className="absolute top-2 left-2 text-[8px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-white/90 text-amber-700">{p.tag}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <div className="text-[11px] text-goldPrimary">{'★'.repeat(p.stars)}<span className="text-stone-300">{'★'.repeat(5 - p.stars)}</span></div>
                <p className="text-[13px] font-semibold text-astroDark leading-snug mt-1">{p.name}</p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-stone-100 mt-auto">
                  <span className="num text-base font-bold text-goldAccent">₹{p.price.toLocaleString('en-IN')}</span>
                  <button className="text-[9px] font-bold uppercase tracking-wider px-3 py-2 rounded-lg bg-gradient-to-r from-goldAccent to-goldPrimary text-astroDark">Add to Cart</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
